import PropTypes from "prop-types";

export const alertPropTypes = PropTypes.shape({
  alertId: PropTypes.string,
  mlsIds: PropTypes.arrayOf(PropTypes.number),
  leadId: PropTypes.string,
  source: PropTypes.string,
  events: PropTypes.arrayOf(PropTypes.string),
  searchName: PropTypes.string,
  frequency: PropTypes.string,
  active: PropTypes.bool,
  activeForEmails: PropTypes.bool,
  activeForAppNotifications: PropTypes.bool,
  isSending: PropTypes.bool,
  reasonDisabled: PropTypes.string,
  requirePhotos: PropTypes.bool,
  requireOpenHouses: PropTypes.bool,
  schoolDistricts: PropTypes.arrayOf(PropTypes.string),
  searchUrl: PropTypes.string,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
});

export const alertDefaultProps = {
  alertId: "",
  mlsIds: [],
  leadId: "",
  source: "",
  events: [],
  searchName: "",
  frequency: "",
  active: false,
  activeForEmails: false,
  activeForAppNotifications: false,
  isSending: false,
  reasonDisabled: "",
  requirePhotos: false,
  requireOpenHouses: false,
  schoolDistricts: [],
  searchUrl: "",
  createdAt: "",
  updatedAt: "",
};

export const truncateText = (text, maxLength) => {
  const safeText = String(text || "");

  return safeText.length > maxLength ? `${safeText.slice(0, maxLength)}...` : safeText;
};

export const ContactShape = PropTypes.shape({
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,

  intent: PropTypes.string,
  created_at: PropTypes.string,
  direct_url: PropTypes.string,
  primary_agent_uuid: PropTypes.string,

  email_address: PropTypes.string,
  envelope_salutation: PropTypes.string,
  letter_salutation: PropTypes.string,

  mailing_street_address: PropTypes.string,
  mailing_city: PropTypes.string,
  mailing_locality: PropTypes.string,
  mailing_postal_code: PropTypes.string,
  mailing_secondary_address: PropTypes.string,

  home_street_address: PropTypes.string,
  home_city: PropTypes.string,
  home_locality: PropTypes.string,
  home_postal_code: PropTypes.string,
  home_secondary_address: PropTypes.string,

  work_street_address: PropTypes.string,
  work_city: PropTypes.string,
  work_locality: PropTypes.string,
  work_postal_code: PropTypes.string,
  work_secondary_address: PropTypes.string,

  investment_street_address: PropTypes.string,
  investment_city: PropTypes.string,
  investment_locality: PropTypes.string,
  investment_postal_code: PropTypes.string,
  investment_secondary_address: PropTypes.string,

  other_street_address: PropTypes.string,
  other_city: PropTypes.string,
  other_locality: PropTypes.string,
  other_postal_code: PropTypes.string,
  other_secondary_address: PropTypes.string,
});

const mapAddresses = (data = []) => {
  return (data || []).map((address) => ({
    attributes: address,
    type: "address",
  }));
};

export const mapToContactPayload = (arr = []) => {
  return arr.map((item) => {
    const included = item?.included || mapAddresses(item?.addresses || []) || [];
    // Start with base payload
    const contact = {
      first_name: item.first_name,
      last_name: item.last_name,
      uuid: item.uuid,

      intent: item.lead_type || item.intent,
      created_at: item.created_at,
      direct_url: item?.direct_url,
      primary_agent_uuid: item.primary_agent_uuid,

      email_address: item.main_email || item.email_address,
      envelope_salutation: item.envelope_salutation,
      letter_salutation: item.letter_salutation,
    };

    // Map addresses dynamically from included
    included
      .filter((i) => i.type === "address")
      .forEach((addr) => {
        const a = addr.attributes;
        const type = a.address_type; // home | work | mailing | other

        if (!type) return;

        if (a.street_address != null) contact[`${type}_street_address`] = a.street_address;

        if (a.city != null) contact[`${type}_city`] = a.city;

        if (a.locality != null) contact[`${type}_locality`] = a.locality;

        if (a.postal_code != null) contact[`${type}_postal_code`] = a.postal_code;

        if (a.secondary_address != null) contact[`${type}_secondary_address`] = a.secondary_address;
      });

    return contact;
  });
};
